import '../scss/style.scss'
import './agree-check'
import './return-top'
import { formValidation } from './form_validation'
import './fade_in_out'
import './fixed_btn_remove'

formValidation()
